import React, { Component, PropTypes } from 'react';
import {toMoneyFormat} from '../../../tools/number'

class AnimationCount extends Component {
    static displayName = 'AnimationCount';

    static propTypes = {
        start: PropTypes.number,
        count: PropTypes.number,
        duration: PropTypes.number,
        decimals: PropTypes.number,
        useGroup: PropTypes.bool,
        useMoneyFormat: PropTypes.bool,
    }

    constructor(props) {
        super(props);
        this.state = {
            value: this.formatNumber(this.props.start, this.props.decimals, this.props.useGroup, this.props.useMoneyFormat),
            startTime: new Date().getTime(),
        };
    }

    componentDidMount() {
        this.setTimer();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const propsFlag = !this.equalObject(this.props, nextProps);
        if (propsFlag) {
            this.setState({
                value: this.formatNumber(this.props.start),
                startTime: new Date().getTime(),
            });
            this.clearTimer();
            this.setTimer();
            return true;
        }
        const stateFlag = !this.equalObject(this.state, nextState);
        if (stateFlag) {
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    formatNumber = (number, decimals, useGroup, useMoneyFormat) => {
        let str = parseFloat(number).toFixed(decimals);
        if (useGroup) {
            if (number < 0) {
                str = str.substring(1, str.length);
            }
            let array1 = str.split('.')[0].split('').reverse().join('');
            array1 = array1.replace(/(\d{3})(?=[^$])/g, '$1 ');
            array1 = array1.split('').reverse().join('');

            if (decimals >= 1) {
                const array2 = str.split('.')[1];
                str = `${array1}.${array2}`;
            } else {
                str = array1;
            }
            if (number < 0) {
                str = `-${str}`;
            }
        } else if (useMoneyFormat) {
            str = toMoneyFormat(str);
        }
        return str;
    }

    equalObject = (x, y) => {
        if (x === y) {
            return true;
        }

        if (!(x instanceof Object) || !(y instanceof Object)) {
            return false;
        }

        if (x.constructor !== y.constructor) {
            return false;
        }

        for (const p in x) {
            if (Object.prototype.hasOwnProperty.call(x, p)) {
                if (!Object.prototype.hasOwnProperty.call(y, p)) {
                    return false;
                }

                if (x[p] !== y[p]) {
                    if (typeof (x[p]) !== 'object') {
                        return false;
                    }

                    if (!this.equalObject(x[p], y[p])) {
                        return false;
                    }
                }
            }
        }
        for (const p in y) {
            if (Object.prototype.hasOwnProperty.call(y, p) && !Object.prototype.hasOwnProperty.call(x, p)) {
                return false;
            }
        }
        return true;
    }


    setTimer = () => {
        if (this.timer) {
            return;
        }
        this.timer = setInterval(() => {
            const t = new Date().getTime() - this.state.startTime;
            const b = this.props.start;
            const c = this.props.count - this.props.start;
            const d = this.props.duration;
            let result;
            if (t < this.props.duration) {
                result = this.countUp(t, b, c, d);
            } else {
                result = this.formatNumber(this.props.count, this.props.decimals, this.props.useGroup, this.props.useMoneyFormat);
                clearInterval(this.timer);
            }
            this.setState({ value: result });
        }, 10);
    }

    clearTimer = () => {
        clearInterval(this.timer);
        this.timer = null;
    }

    countUp = (t, b, c, d) => {
        let result = parseFloat(((c * (-(2 ** ((-10 * t) / d)) + 1) * 1024) / 1023) + b);
        result = this.formatNumber(result, this.props.decimals, this.props.useGroup, this.props.useMoneyFormat);
        return result;
    }

    render() {
        return (
            <span>{this.state.value}</span>
        );
    }
}

export default AnimationCount;


// WEBPACK FOOTER //
// ./client/components/AnimationCount/AnimationCount.js